import ApplicationConfig from 'providers/useConfig/ApplicationConfig';
import { EditorialItem, ModuleConfigs } from 'types/Config';
import { PATH_COLLECTION, PATH_EDITORIAL } from './fnRouting';
import { getStripeEditorialModulePageId, isCollectionItem, isViewAllLink } from './fnEditorial';

export const getEditorialCollectionItem = (moduleConfig?: ModuleConfigs): EditorialItem | null => {
    if (!moduleConfig || !moduleConfig.items || !moduleConfig.items.length) {
        return null;
    }
    return moduleConfig.items.length === 1 && moduleConfig.items[0];
};

export const getCollectionNavigationPath = (
    showAll: boolean,
    config: typeof ApplicationConfig,
    collectionId?: string,
    editorialAll?: EditorialItem,
    pagePath?: string
): string | null => {
    if (!showAll) {
        return null;
    }

    const isCollectionLink = isViewAllLink(editorialAll) || isCollectionItem(editorialAll);
    const editorialType = isCollectionLink ? `/${PATH_COLLECTION}` : '';
    const collectionAllId = getStripeEditorialModulePageId(editorialAll);

    // is this check needed? search page won't work with it on wtf
    /*
    if (isCollectionLink && !collectionAllId) {
        return null;
    }
    */

    let editorialPath = editorialAll
        ? `${editorialType}${
              isCollectionLink
                  ? `/${collectionAllId}`
                  : `${config.getPagePath(editorialAll.action.menu_tab_id || editorialAll.action.page_id)}`
          }`
        : null;

    if (isCollectionLink && editorialAll?.action?.module?.foreignId) {
        editorialPath += `/${editorialAll.action.module.foreignId}`;
    }

    if (pagePath) {
        const collectionUrl = collectionId ? `/${PATH_COLLECTION}/${pagePath}/${collectionId}` : `/${PATH_COLLECTION}/${pagePath}`;
        return editorialPath || collectionUrl;
    }

    return editorialPath || null;
};

export const editorialPathVarToId = (pathVar: string): string => pathVar.replace(`${PATH_EDITORIAL}-`, '').replace(/-/g, '_');
